import { render, staticRenderFns } from "./WishListFloatItem.vue?vue&type=template&id=49e5c1db&scoped=true"
import script from "./WishListFloatItem.vue?vue&type=script&lang=js"
export * from "./WishListFloatItem.vue?vue&type=script&lang=js"
import style0 from "./WishListFloatItem.vue?vue&type=style&index=0&id=49e5c1db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e5c1db",
  null
  
)

export default component.exports